import { useUploadPhotoId } from "@internal/telemedicine"
import { usePhotoIdTracking } from "./usePhotoIdTracking"

export function useUploadIdDocuments() {
  const { onUploadCompleted } = usePhotoIdTracking()
  return useUploadPhotoId(onUploadCompleted)
}
